<section class="users-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions class="users-page__meta">
      <span>{{ totalItems }} conta(s)</span>
      <button class="admin-btn admin-btn--primary" type="button" (click)="openCreateUserDialog()">
        Novo usuário
      </button>
    </div>
  </app-admin-page-header>

  <div class="users-toolbar admin-surface">
    <div class="users-toolbar__search">
      <i class="pi pi-search"></i>
      <input
        type="text"
        class="admin-input"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchInputChange($event)"
        (keydown.enter)="onSearchChange()"
        placeholder="Nome, email, documento, username ou gamertag" />
    </div>

    <label class="users-toolbar__filter">
      <input type="checkbox" [(ngModel)]="hasAlert" (change)="onFilterChange()" />
      Com alertas
    </label>

    <label class="users-toolbar__filter">
      <input type="checkbox" [(ngModel)]="isLimited" (change)="onFilterChange()" />
      Limitadas
    </label>

    <div class="users-toolbar__actions">
      <button class="admin-btn admin-btn--primary" (click)="onSearchChange()">Pesquisar</button>
      <button class="admin-btn admin-btn--secondary" (click)="clearFilters()">Limpar</button>
    </div>
  </div>

  <div class="users-table-wrapper admin-surface">
    <p-table
      [value]="users"
      [paginator]="true"
      [rows]="rowsPerPage"
      [totalRecords]="totalItems"
      [lazy]="true"
      [loading]="isLoading"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Conta</th>
          <th>Email</th>
          <th>Documento</th>
          <th>Gamertags</th>
          <th>Alertas</th>
          <th>Status</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr [class.limited-user]="user.is_limited">
          <td>{{ user.id }}</td>
          <td>
            <button
              type="button"
              class="users-account-link users-table__identity"
              (click)="viewDetails(user.id)"
              [attr.aria-label]="'Ver detalhes da conta ' + user.id">
              <strong>{{ getUserName(user) }}</strong>
              <small>&#64;{{ user.username }}</small>
            </button>
          </td>
          <td>{{ user.email }}</td>
          <td>{{ user.document_number || '-' }}</td>
          <td>
            <div class="users-table__chips" *ngIf="user.gamer_names.length > 0; else emptyGamerName">
              <span class="users-chip" *ngFor="let name of user.gamer_names">{{ name }}</span>
            </div>
            <ng-template #emptyGamerName>
              <span class="users-table__empty">Sem gamertag</span>
            </ng-template>
          </td>
          <td>
            <div class="users-table__chips" *ngIf="user.alerts.length > 0; else emptyAlerts">
              <span
                class="users-chip users-chip--danger"
                *ngFor="let alert of getAlertPreview(user)"
                [pTooltip]="alert"
                tooltipPosition="top">
                {{ alert }}
              </span>
              <span *ngIf="user.alerts.length > 2" class="users-chip users-chip--count">
                +{{ user.alerts.length - 2 }}
              </span>
            </div>
            <ng-template #emptyAlerts>
              <span class="users-table__empty">Sem alertas</span>
            </ng-template>
          </td>
          <td>
            <app-admin-status-badge [limited]="user.is_limited"></app-admin-status-badge>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="users-table__empty-message">
            <div *ngIf="isLoading" class="users-empty-state">
              <p-progressSpinner ariaLabel="Carregando usuários" strokeWidth="6"></p-progressSpinner>
              <span>Carregando usuários...</span>
            </div>
            <div *ngIf="!isLoading" class="users-empty-state">
              <i class="pi pi-users"></i>
              <span>Nenhuma conta encontrada para os filtros selecionados.</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog
    header="Criar usuário"
    [(visible)]="isCreateDialogVisible"
    [modal]="true"
    [appendTo]="'body'"
    position="center"
    [draggable]="false"
    maskStyleClass="create-user-dialog-mask"
    [dismissableMask]="true"
    [style]="{ width: '36rem', maxWidth: '95vw' }"
    styleClass="create-user-dialog">
    <form class="create-user-form" (ngSubmit)="createUser()">
      <label>
        Email
        <input
          type="email"
          class="admin-input"
          name="email"
          [(ngModel)]="createUserForm.email"
          required />
      </label>

      <label>
        CPF
        <input
          type="text"
          class="admin-input"
          name="document_number"
          [(ngModel)]="createUserForm.document_number"
          maxlength="14"
          required />
      </label>

      <label>
        Data de nascimento
        <input
          type="date"
          class="admin-input"
          name="birthdate"
          [(ngModel)]="createUserForm.birthdate"
          required />
      </label>

      <label>
        Senha
        <input
          type="password"
          class="admin-input"
          name="password"
          [(ngModel)]="createUserForm.password"
          required />
      </label>

      <label>
        Confirmar senha
        <input
          type="password"
          class="admin-input"
          name="confirm_password"
          [(ngModel)]="createUserForm.confirm_password"
          required />
      </label>

      <label class="create-user-form__checkbox">
        <input
          type="checkbox"
          name="skip_document_validation"
          [(ngModel)]="createUserForm.skip_document_validation" />
        Pular validação da APIBrasil
      </label>

      <p class="create-user-form__error" *ngIf="createUserError">{{ createUserError }}</p>

      <div class="create-user-form__actions">
        <button
          type="button"
          class="admin-btn admin-btn--secondary"
          (click)="closeCreateUserDialog()"
          [disabled]="isCreatingUser">
          Cancelar
        </button>
        <button type="submit" class="admin-btn admin-btn--primary" [disabled]="isCreatingUser">
          {{ isCreatingUser ? 'Criando...' : 'Criar usuário' }}
        </button>
      </div>
    </form>
  </p-dialog>
</section>
